import type { ActKc3TotalData } from 'gql/graphql';
import { UerTotal_AlcTypeEnum as UerTotalAlcTypeEnum } from 'gql/graphql';
import { Button, cnMixSpace, IconArrowDown, IconArrowUp } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import { useCallback } from 'react';

interface TNameCellRenderer extends ICellRendererParams<ActKc3TotalData> {
    toggleOthersCollapse: () => void;
    othersCollapseState: boolean;
    hasNotOthersData: boolean;
}

export const NameCell = (props: TNameCellRenderer) => {
    const { value, toggleOthersCollapse, data, othersCollapseState, hasNotOthersData } = props;

    const toggleState = useCallback(() => {
        toggleOthersCollapse();
    }, [toggleOthersCollapse]);

    if (!data) {
        return '';
    }

    if (data?.totalType && data?.totalType === UerTotalAlcTypeEnum.Others) {
        return (
            <>
                {!hasNotOthersData && (
                    <Button
                        onlyIcon
                        size="xs"
                        view="clear"
                        iconRight={othersCollapseState ? IconArrowUp : IconArrowDown}
                        onClick={toggleState}
                        className={cnMixSpace({
                            mR: 'xs',
                        })}
                    />
                )}
                {value}
            </>
        );
    }

    return data?.totalType === UerTotalAlcTypeEnum.Other ? (
        <span
            className={cnMixSpace({
                mL: '4xl',
            })}
        >
            {value}
        </span>
    ) : (
        value
    );
};

NameCell.displayName = 'NameCell';
